<!-- ChoiceButton.vue -->
<script lang="ts" setup>
    import * as ButtonProps from '../../lib/ButtonProps';
    import "../../../css/choice.css"
    import {IButtonProps } from '../../lib/ButtonProps';
    import { ActionButtonStyle, DefaultActionButtonValues } from '../../lib/Types/Types';
    import { DisplayStyle } from '../../Enums/UiEnums';
    import { computed } from 'vue';
    import { bootstrapMarginLeftClass, bootstrapMarginRightClass, BootstrapPaddingValue, iconClass } from '../../lib/StyleHelpers';
    import "../../../css/choice.css"

    const props = withDefaults(defineProps<IButtonProps & {
        marginStart?: BootstrapPaddingValue,
        marginEnd?: BootstrapPaddingValue,
        count?: number
    }>(), {
        disabled: false,
        displayStyle: DisplayStyle.Primary,
        marginStart: 0,
        marginEnd: 1,
        action: ActionButtonStyle.NoIcon
    });

    const emit = defineEmits<{
        click: []
    }>();

    const computedButtonClass = computed(() => {
        return [ButtonProps.getButtonClass(props), bootstrapMarginLeftClass(props.marginStart), bootstrapMarginRightClass(props.marginEnd)].join(' ');
    });

    const computedButtonStyle = computed(() => {
        return ButtonProps.getButtonStyle(props);
    });    

    const defaultActionButtonValues = computed(() => DefaultActionButtonValues(props.action));    
    
    const computedActionIconClass = computed(() => 
        [defaultActionButtonValues.value.iconClass ?? iconClass(props.icon), "text-center", "me-1"]);

    const buttonDisplayedText = computed<string>(() => {
        return (props.text ?? defaultActionButtonValues.value.baseText ?? props.action.toString() ?? "Button" );
    });

    const countDisplayClass = "d-inline-flex align-items-center justify-content-center bg-white text-primary fw-bold rounded-circle ms-2";
    const countDisplayStyle = { padding: '0.25rem', fontSize: 'x-small' };

    function onClick()
    {
        emit("click");
    }

</script>

<template>
    <button :class="computedButtonClass" :disabled="props.disabled" @click="onClick" :style="computedButtonStyle" :title="props.tooltip">    
        <em v-if="props.action != ActionButtonStyle.NoIcon" :class="computedActionIconClass" :displayStyle="props.iconDisplayStyle"></em>
        <slot>
            {{buttonDisplayedText}}
        </slot>
        <div v-if="props.count !== undefined" :class="countDisplayClass" :style="countDisplayStyle">{{ props.count }}</div>
    </button>
  </template>